import apiClient from '../middleware/apiClient';
import { COTTON_OUTAGE, OUTAGE } from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { flagEnabled } from '../helpers/featureFlags';
import { kibanaLog } from '../helpers/logger';
import { getConsolidatedOutageLob } from './consolidatedOutage';

export const GET_OUTAGE = 'GET_OUTAGE';
export const GET_OUTAGE_SUCCESS = 'GET_OUTAGE_SUCCESS';
export const GET_OUTAGE_FAILURE = 'GET_OUTAGE_FAILURE';

function dispatchGetOutage(endpoint = OUTAGE) {
  return {
    type: GET_OUTAGE,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetOutageSuccess(outage) {
  return {
    type: GET_OUTAGE_SUCCESS,
    payload: outage,
  };
}

function dispatchGetOutageFailure(error) {
  return {
    type: GET_OUTAGE_FAILURE,
    payload: error,
  };
}

export const getOutage = () => async (dispatch, getState) => {
  if (getState().outage.requested) {
    return null;
  }

  try {
    let response;
    const { isAptV1Enabled, outageEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('apt_v1_outage_api_called');
      response = await dispatch(dispatchGetOutage(COTTON_OUTAGE)).payload;
    } else if (outageEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => dispatchGetOutage(COTTON_OUTAGE),
        () => dispatchGetOutage(OUTAGE),
        'outage',
      );
    } else {
      // Only call Ruby API
      response = await dispatch(dispatchGetOutage(OUTAGE)).payload;
    }

    return dispatch(dispatchGetOutageSuccess(response));
  } catch (error) {
    return dispatch(dispatchGetOutageFailure(error));
  }
};

// Fetch outage for the Devices page, mirroring legacy `enableOutageLob` gating.
export const getDeviceOutage = () => dispatch => (
  flagEnabled('enableOutageLob')
    ? dispatch(getConsolidatedOutageLob())
    : dispatch(getOutage())
);
